import { render, staticRenderFns } from "./TableFreeWordRow.vue?vue&type=template&id=05cb3c0a&"
import script from "./TableFreeWordRow.vue?vue&type=script&lang=js&"
export * from "./TableFreeWordRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports